
























































































































































































































































































































































































































































































import { Vue, Component, Prop, Watch, Ref } from 'vue-property-decorator'
import EdicaoGenerica from '@/components/layout/EdicaoGenerica.vue'
import { SaveProdutoUseCase, FindProdutoUseCase, AdicionarItensEmLoteUseCase, FindTabelaDePrecoUseCase, FindOrigemUseCase } from '@/usecases'
import type { TipoDeProduto } from '@/models'
import {
	Produto,
	ProdutoBase,
	FormProduto,
	RegraFiscalDeProduto,
	ProdutoComVariantes,
	Variante,
	ImagensProduto,
	AtributosDaVariante,
	ItemDaTabelaDePreco,
	TabelaDePreco,
	Origem,
} from '@/models'
import Confirmacao from '@/components/ui/Confirmacao.vue'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import SeletorDeTag from '@/components/produto/SeletorDeTag.vue'
import SeletorDeMarca from '@/components/produto/SeletorDeMarca.vue'
import SeletorDeGenero from '@/components/produto/SeletorDeGenero.vue'
import SeletorDeNcm from '@/components/ui/SeletorDeNcm.vue'
import SeletorDeCest from '@/components/produto/SeletorDeCest.vue'
import SeletorDeUnidadeDeMedida from '@/components/produto/SeletorDeUnidadeDeMedida.vue'
import DialogoDeEansDeProduto from '@/components/produto/DialogoDeEansDeProduto.vue'
import CamposDeProdutoPadrao from './CamposDeProdutoPadrao.vue'
import CamposDeProdutoComVariantes from './CamposDeProdutoComVariantes.vue'
import CamposDeProdutoComposto from './CamposDeProdutoComposto.vue'
import CamposAvancadosDoProduto from './CamposAvancadosDoProduto.vue'
import { ProdutoModule } from '@/store/vuex/produto/ProdutoStore'
import { obrigatorio, maiorOuIgualAZero } from '@/shareds/regras-de-form'
import SeletorDeCategoria from '@/views/application/produtos/EdicaoDeProduto/SeletorDeCategoria.vue'
import {
	converterProdutoParaProdutoPadrao,
	converterProdutoParaProdutoComVariantes,
	converterProdutoParaProdutoComposto,
	criarProduto,
} from '@/shareds/produto-shareds'
import { nextTick } from '@/shareds/utils'
import UserLoginStore from '@/store/vuex/authentication/UserLoginStore'
import AppStore from '@/store/vuex/aplicacao/AppStore'
import SeletorDeEstacao from '@/components/produto/SeletorDeEstacao.vue'
import SeletorDeFornecedor from '@/components/fornecedor/SeletorDeFornecedor.vue'
import DialogoDeProdutosRelacionados from '@/components/produto/DialogoDeProdutosRelacionados.vue'
import DialogoDeAdicionarImagemAoProduto from '@/components/produto/DialogoDeAdicionarImagemAoProduto.vue'
import SeletorDeFamiliaDoProduto from '@/components/produto/SeletorDeFamiliaDoProduto.vue'

function simplificarRegraFiscal(regraFiscal: RegraFiscalDeProduto): RegraFiscalDeProduto {
	if (!regraFiscal.regra) return regraFiscal
	return {
		...regraFiscal,
		regra: {
			id: regraFiscal.regra.id,
			descricao: regraFiscal.regra.descricao,
			origem: regraFiscal.regra.origem,
			regimeFiscal: regraFiscal.regra.regimeFiscal,
		},
	} as RegraFiscalDeProduto
}

// Campos da variante que o backend lê ao criar/editar produto com variantes
// (VarianteForm.toVarianteCreateProdutoVariante). Os demais (variantes vinculadas,
// fornecedor, família etc.) eram descartados no backend e só inflavam a requisição
function camposDaVarianteLidosNoSalvar(variante: Variante): Partial<Variante> {
	return {
		id: variante.id,
		tipo: variante.tipo,
		sku: variante.sku,
		nome: variante.nome,
		nomeCompleto: variante.nomeCompleto,
		descricao: variante.descricao,
		eans: variante.eans,
		tags: variante.tags,
		badges: variante.badges,
		urlImagens: variante.urlImagens,
		preco: variante.preco,
		pesoLiquido: variante.pesoLiquido,
		pesoBruto: variante.pesoBruto,
		descontoVarejo: variante.descontoVarejo,
		atributosVariante: variante.atributosVariante,
		produtoDesativado: variante.produtoDesativado,
		produtoIncompleto: variante.produtoIncompleto,
		fatorDeConversao: variante.fatorDeConversao,
		unidadeDeConversao: variante.unidadeDeConversao,
		tipoDaOrigemDoProduto: variante.tipoDaOrigemDoProduto,
		codigoOrigemDoProduto: variante.codigoOrigemDoProduto,
	}
}

@Component({
	components: {
		EdicaoGenerica,
		SeletorDeTag,
		SeletorDeMarca,
		SeletorDeGenero,
		CamposDeProdutoPadrao,
		CamposDeProdutoComVariantes,
		CamposDeProdutoComposto,
		CamposAvancadosDoProduto,
		SeletorDeNcm,
		SeletorDeCest,
		DialogoDeEansDeProduto,
		SeletorDeUnidadeDeMedida,
		SeletorDeCategoria,
		SeletorDeEstacao,
		SeletorDeFornecedor,
		DialogoDeProdutosRelacionados,
		DialogoDeAdicionarImagemAoProduto,
		SeletorDeFamiliaDoProduto,
		Confirmacao,
	},
})
export default class EdicaoDeProduto extends Vue {
	@Ref() edicaoGenerica!: EdicaoGenerica<Produto>
	@Prop({ type: String }) id!: string | undefined
	@Prop({ type: Boolean }) novo!: boolean
	campoDeDesconto!: HTMLInputElement
	@Ref() dialogoDeProdutosRelacionados!: DialogoDeProdutosRelacionados
	@Ref() dialogoDeAdicionarImagemAoProduto!: DialogoDeAdicionarImagemAoProduto
	@Ref() confirmacaoDeAdicionarNaTabelaDePreco!: Confirmacao

	appStore = AppStore
	obrigatorio = obrigatorio
	maiorOuIgualAZero = maiorOuIgualAZero

	podeAlterarCampoDeDesconto = false
	produto: FormProduto | null = null
	versaoAnterior: FormProduto | null = null
	versaoInicial: FormProduto | null = null
	carregando = true
	salvando = false
	img: ImagensProduto | null = null

	erro: null | Error = null

	criaSkuAutomaticamente = false

	dialogoDeDuplicacao = false
	duplicacaoNome = ''
	duplicacaoSkuPai = ''
	duplicacaoManterGrade: boolean | null = null
	mostrarVariantesDuplicacao = false

	saveUseCase = new SaveProdutoUseCase()
	findUseCase = new FindProdutoUseCase()
	adicionarItensEmLoteUseCase = new AdicionarItensEmLoteUseCase()
	findTabelaDePrecoUseCase = new FindTabelaDePrecoUseCase()
	findOrigemUseCase = new FindOrigemUseCase()

	origens: Origem[] = []

	tipos: {
		text: string
		value: 'Padrão' | 'Com Variantes' | 'Composto'
		descricao: string
	}[] = [
		{
			text: 'Padrão',
			value: 'Padrão',
			descricao: 'Produto único e sem variantes',
		},
		{
			text: 'Com Variantes',
			value: 'Com Variantes',
			descricao: 'Possui variações como Cor e Tamanho',
		},
		{
			text: 'Composto',
			value: 'Composto',		
			descricao: 'Composto por mais produtos como "Kits" ou "Combos"',
		},
	]

	@Watch('id', { immediate: true })
	onChangeId() {
		this.carregar()
	}

	created() {
		this.carregarOrigens()
	}

	async carregar() {
		try {
			this.carregando = true
			this.criaSkuAutomaticamente = false
			this.produto = criarProduto()
			if (!this.novo) {
				this.produto = await this.findUseCase.findProdutoById(this.id as string)
			} else if (ProdutoModule.produtoParaDuplicar) {
				this.produto = ProdutoModule.produtoParaDuplicar
				ProdutoModule.setProdutoParaDuplicar(null)
			}
			if (this.produto) {
				(this.produto as any).codigoOrigemDoProduto = this.normalizeCodigoOrigem((this.produto as any).codigoOrigemDoProduto)
				Vue.set(this.produto, 'badges', this.produto.badges || [])
				if (this.produto.tipo === 'Com Variantes') {
					((this.produto as any).variantes || []).forEach((variante: any) => {
						Vue.set(variante, 'badges', variante.badges || [])
					})
				}
			}
			this.atualizarVersaoAnterior()
			this.versaoInicial = this.produto
			if(this.produto.urlImagens) {
				const padrao = this.produto.urlImagens.filter(imagem => imagem.padrao)[0]
				this.img = padrao
			}
		} catch (error: any) {
			AlertModule.setError(error)
		} finally {
			this.$nextTick(() => {
				this.carregando = false
			})
		}
	}

	get podeConcederDesconto() {
		return UserLoginStore.permiteRegraDeNegocio('pode-conceder-desconto')
	}

	mesclarBadgesComOsDoProdutoPai(badgesDoProdutoPai: string[] | undefined, badgesDaVariante: string[] | undefined): string[] {
		const badgesMesclados = new Set(badgesDaVariante || [])
		;(badgesDoProdutoPai || []).forEach(badge => badgesMesclados.add(badge))
		return Array.from(badgesMesclados)
	}

	async salvar() {
		if (!this.produto) return

		if(this.produto.produtoIntegrado && !this.podeEditarProdutoIntegrado) 
			return AlertModule.setError("Esse usuário não possui a permissão para editar produtos integrados")
		if (this.produto.tipo === 'Composto') {
			this.produto.descontoVarejo = 0
		}

		if (!this.produto.unidadeDeMedida || this.produto.unidadeDeMedida === ''){
			return AlertModule.setError("Obrigatório informar unidade de medida")
		}

		try {
			this.salvando = true
			const produto = {
				...this.produto,
				isValePresente: this.produto.tipo === 'Padrão' 
					? this.produto.isValePresente 
					: false,
				fornecedor: this.produto.fornecedor,
				estacao: this.produto.estacao,
				genero: this.produto.genero,	
			} as Produto
			this.atualizarVersaoAnterior()
			// O backend só lê id, descricao, origem e regimeFiscal da regra; o restante
			// (regras de aplicação por UF, NCMs por transação) só aumentava o payload
			produto.regrasFiscais = (produto.regrasFiscais || []).map(simplificarRegraFiscal)
			if (produto.tipo === 'Com Variantes') {
				const regrasFiscaisDasVariantes = produto.regrasFiscais

				if (produto.marca) produto.marca.lojas = []

				// Estoque por variação é só exibição e não é lido no salvar
				delete (produto as Partial<ProdutoComVariantes>).estoquesPorVariacao

				produto.variantes = produto.variantes.map(variante => ({
					...camposDaVarianteLidosNoSalvar(variante),
					nome: variante.nome || produto.nome,
					ncm: produto.ncm,
					cest: produto.cest,
					preco: variante.preco || produto.preco,
					pesoLiquido: produto.pesoLiquido !== this.versaoAnterior?.pesoLiquido? produto.pesoLiquido : variante.pesoLiquido,
					pesoBruto: produto.pesoBruto !== this.versaoAnterior?.pesoBruto ? produto.pesoBruto : variante.pesoBruto,
					descricao: variante.descricao || produto.descricao,
					marca: produto.marca,
					badges: this.mesclarBadgesComOsDoProdutoPai(produto.badges, variante.badges),
					tags: variante.tags,
					temGarantia: produto.temGarantia,
					regrasFiscais: [ ...regrasFiscaisDasVariantes ],
					categoria: produto.categoria,
					unidadeDeMedida: produto.unidadeDeMedida,
					produtoDesativado: variante.produtoDesativado,
					fatorDeConversao: variante.fatorDeConversao,
					unidadeDeConversao: variante.unidadeDeConversao,
				}) as Variante)
			}
			const produtoAtualizado: Produto = this.novo
				? await this.saveUseCase.create(produto as Produto)
				: await this.saveUseCase.update(produto as Produto)
			this.novo
				? ProdutoModule.addProduto(produtoAtualizado)
				: ProdutoModule.atualizaProduto(produtoAtualizado)

			AlertModule.setSuccess('Produto salvo com sucesso')
			if (this.novo) {
				await this.perguntarEAdicionarNaTabelaDePrecoDoUsuario(produtoAtualizado)
				this.$router.push({
					name: 'Produto',
					params: {
						id: produtoAtualizado.id as string,
					},
				})
			}
			this.produto = null
			this.produto = produtoAtualizado
			AlertModule.setSuccess('Produto salvo com sucesso')
			this.atualizarVersaoAnterior()
			
			this.carregar()
		} catch (error: any) {
			AlertModule.setError(error)
		} finally {
			this.salvando = false
		}
	}

	async perguntarEAdicionarNaTabelaDePrecoDoUsuario(produtoCriado: Produto) {
		if (!produtoCriado.preco) return
		const tabelaDePrecoId = UserLoginStore.usuario?.tabelaDePrecoId
		if (!tabelaDePrecoId) return

		try {
			const tabelaDePreco = await this.findTabelaDePrecoUseCase.get(tabelaDePrecoId)
			const confirmou = await this.confirmacaoDeAdicionarNaTabelaDePreco.mostrarComParametros(
				'Adicionar à tabela de preço?',
				`Deseja incluir o preço do cabeçalho na tabela de preço "${tabelaDePreco.nome}"?`,
			)
			if (!confirmou) return

			const produtosParaAdicionar: Produto[] = produtoCriado.tipo === 'Com Variantes'
				? produtoCriado.variantes
				: [produtoCriado]

			const itens = produtosParaAdicionar.map(produtoOuVariante =>
				criarItemDaTabelaDePreco(produtoOuVariante, produtoCriado.preco as number, tabelaDePreco),
			)
			await this.adicionarItensEmLoteUseCase.adicionarItensEmLote(tabelaDePreco.id, itens)

			AlertModule.setSuccess('Produto adicionado à tabela de preço com sucesso')
		} catch (error: any) {
			AlertModule.setError(error)
		}
	}

	get labelDoCampoDePreco() {
		switch (this.produto?.tipo) {
			case 'Composto':
				return 'Preço Total'
			case 'Com Variantes':
				return 'Preço Base'
			default:
				return 'Preço'
		}
	}

	get labelDoCampoDePesoLiquido() {
		switch (this.produto?.tipo) {
			case 'Com Variantes':
				return 'Peso Liquido Base'
			default:
				return 'Peso Liquido'
		}
	}

	get labelDoCampoDePesoBruto() {
		switch (this.produto?.tipo) {
			case 'Com Variantes':
				return 'Peso Bruto Base'
			default:
				return 'Peso Bruto'
		}
	}

	get ComponenteDoTipoDeProduto() {
		switch (this.produto?.tipo) {
			case 'Padrão':
				return 'CamposDeProdutoPadrao'
			case 'Com Variantes':
				return 'CamposDeProdutoComVariantes'
			case 'Composto':
				return 'CamposDeProdutoComposto'
			default:
				return 'div'
		}
	}

	get podeEditar() {
		return this.edicaoGenerica.podeEditar
	}


	get podeEditarProdutoIntegrado() {
		return UserLoginStore.permiteRegraDeNegocio('pode-editar-produto-integrado')
	}
	@Watch('produto.tipo')
	onChangeTipoDeProduto(tipo: TipoDeProduto) {
		if (!this.produto) return

		switch (tipo) {
			case 'Padrão':
				this.produto = converterProdutoParaProdutoPadrao(this.produto)
				break
			case 'Com Variantes':
				this.produto = converterProdutoParaProdutoComVariantes(
					this.produto,
				)
				break
			case 'Composto':
				this.produto = converterProdutoParaProdutoComposto(this.produto)
				break
			default:
				throw new Error('Conversão inesperada')
		}
	}

	async beforeRouteUpdate(to,from,next) {
		next(!await this.edicaoGenerica.validarTransicao())
	}

	async beforeRouteLeave(to, from, next) {
		next(!await this.edicaoGenerica.validarTransicao())
	}

	atualizarVersaoAnterior() {
		nextTick().then(() => {
			this.versaoAnterior = JSON.parse(JSON.stringify(this.produto))
		})
	}

	abrirDialogoDeProdutosRelacionados(){
		this.dialogoDeProdutosRelacionados.mostrar()
	}

	get codigosOrigemItens() {
		return Array.from({ length: 9 }, (_, i) => {
			const origem = this.origens.find(({ codigo }) => Number(codigo) === i)
			return {
				text: origem ? `${i} - ${origem.descricao}` : String(i),
				value: i,
			}
		})
	}

	async carregarOrigens() {
		try {
			const pagina = await this.findOrigemUseCase.find({ size: 100 })
			this.origens = pagina.content
		} catch (error: any) {
			AlertModule.setError(error)
		}
	}

	set codigoOrigemSelecionado(value: number) {
		if (!this.produto) return
		(this.produto as any).codigoOrigemDoProduto = value
	}

	normalizeCodigoOrigem(value: unknown): number {
		if (value == null) return 0

		const raw = String(value).trim()
		if (!raw) return 0

		const matchOrigem = raw.match(/^ORIGEM_(\d+)$/i)
		if (matchOrigem) return Number.parseInt(matchOrigem[1], 10)

		const matchO = raw.match(/^O(\d+)$/i)
		if (matchO) return Number.parseInt(matchO[1], 10)

		const n = Number.parseInt(raw, 10)
		if (!Number.isNaN(n) && n >= 0 && n <= 8) return n

		return 0
	}

	atualizarImagens(imagens: ImagensProduto[]) {
		if (!this.produto) return
		this.produto.urlImagens = imagens
		this.img = imagens.find(img => img.padrao) ?? null
	}

	get permiteDuplicarProduto() {
		return UserLoginStore.permiteRegraDeNegocio('permite-duplicar-produto')
	}

	abrirConfirmacaoDeDuplicarProduto() {
		if (!this.produto) return
		this.duplicacaoNome = ''
		this.duplicacaoSkuPai = ''
		this.duplicacaoManterGrade = null
		this.mostrarVariantesDuplicacao = false
		this.dialogoDeDuplicacao = true
	}

	get podeConfirmarDuplicacao() {
		if (!this.duplicacaoNome.trim()) return false
		if (!this.duplicacaoSkuPai.trim()) return false
		if (this.produto?.tipo === 'Com Variantes' && this.duplicacaoManterGrade === null) return false
		return true
	}

	get variantesParaDuplicacao() {
		if (!this.produto || this.produto.tipo !== 'Com Variantes') return []
		const produto = this.produto as any
		return (produto.variantes as any[] || []).map(variante => ({
			descricao: (variante.atributosVariante as AtributosDaVariante[] || []).map(a => a.valor).join(' / ') || variante.sku,
			skuGerado: this.gerarSkuVariante(this.duplicacaoSkuPai, variante.atributosVariante || []),
		}))
	}

	gerarSkuVariante(skuPai: string, atributos: AtributosDaVariante[]): string {
		const cor = atributos.find(v => v.nome === 'Cor')?.valor
		const tamanho = atributos.find(v => v.nome === 'Tamanho')?.valor
		const partes = [skuPai]
		if (cor) partes.push(cor.normalize('NFD').replace(/[̀-ͯ]/g, '').toUpperCase().replace(/\s+/g, ''))
		if (tamanho) partes.push(tamanho.normalize('NFD').replace(/[̀-ͯ]/g, '').toUpperCase().replace(/\s+/g, ''))
		return partes.join('')
	}

	confirmarDuplicacao() {
		if (!this.produto) return
		const produtoCopia = JSON.parse(JSON.stringify(this.produto)) as any
		delete produtoCopia.id
		produtoCopia.nome = this.duplicacaoNome
		produtoCopia.sku = this.duplicacaoSkuPai
		produtoCopia.urlImagens = []

		if (produtoCopia.tipo === 'Com Variantes') {
			if (this.duplicacaoManterGrade) {
				produtoCopia.atributosProduto = (produtoCopia.atributosProduto || []).map((attr: any) => ({
					...attr,
					id: undefined,
				}))
				produtoCopia.variantes = (produtoCopia.variantes as any[]).map(variante => ({
					...variante,
					id: undefined,
					sku: this.gerarSkuVariante(this.duplicacaoSkuPai, variante.atributosVariante || []),
					skuPai: this.duplicacaoSkuPai,
					nome: this.duplicacaoNome,
					nomeCompleto: `${this.duplicacaoNome} ${(variante.atributosVariante || []).map((a: any) => a.valor).join(' / ').toUpperCase()}`,
					eans: [],
					identificadores: [],
					urlImagens: [],
					idProdutoPai: undefined,
					varianteVinculada: null,
					vinculada: false,
					produtoIncompleto: false,
					atributosVariante: (variante.atributosVariante || []).map((attr: any) => ({
						...attr,
						id: undefined,
					})),
				}))
			} else {
				produtoCopia.variantes = []
				produtoCopia.atributosProduto = []
			}
		}

		ProdutoModule.setProdutoParaDuplicar(produtoCopia as FormProduto)
		this.dialogoDeDuplicacao = false
		this.$router.push({ name: 'Novo Produto' })
	}
}

const criarItemDaTabelaDePreco = (
	produto: Produto,
	preco: number,
	tabela: TabelaDePreco,
): ItemDaTabelaDePreco => ({
	id: '',
	produto: produto as unknown as ProdutoBase,
	precoCompra: produto.precoCompra ?? preco,
	margemLucro: produto.margemLucro,
	descontoVarejo: produto.descontoVarejo,
	precoFinalVarejo: preco,
	descontoAtacado: null,
	precoFinalAtacado: null,
	qtdeMinimaAtacado: null,
	qtdeMaximaAtacado: null,
	inicioVigencia: null,
	fimVigencia: null,
	inicioVigenciaDesconto: null,
	fimVigenciaDesconto: null,
	limitarProduto: false,
	qtdeLimitadaDoProduto: 0,
	percentualCashback: 0,
	diasParaEfetuarCashback: 0,
	tabela,
	skuProdutoPai: produto.skuPai,
	diasParaExpirarCashback: 0,
})
